import moment from 'moment'
import { formatDynamicAmountWithDollarType } from 'lib/formatCurrency'

interface Args {
  promo: App.Promotion;
  subtotal: number;
  cartCurrency: string;
  appRegion: string;
}

export default function verifyPromo({
  promo,
  subtotal,
  cartCurrency,
  appRegion,
}: Args) {
  let error

  if (new Date() > new Date(promo.expiresAt)) {
    error = `This promo code expired on ${moment(promo.expiresAt).format('MMM Do YYYY')}`
  } else if (promo.currency !== null && promo.currency !== cartCurrency) {
    error = `This promo code has a specified currency - ${promo.currency}`
  } else if (promo.currency !== null && promo.minSpend > subtotal) {
    const minSpend = formatDynamicAmountWithDollarType(promo.minSpend, promo.currency, appRegion)
    error = `Minimum spend for this promo code is ${minSpend}`
  }

  if (error) {
    throw new Error(error)
  }
}
